import type { ICellRendererParams } from "ag-grid-community";

import { isAuditGroupHeaderRow } from "./auditTableUtils";

/** Full-width AG Grid row renderer for sticky-style day group headers. */
export const AuditGroupHeaderCell = ({ data }: ICellRendererParams) => {
  if (!data || !isAuditGroupHeaderRow(data)) {
    return null;
  }

  return (
    <div className="sticky top-0 z-10 flex h-full w-full items-center border-b border-gray-100 bg-white px-3 text-[11px] font-semibold uppercase tracking-wide text-gray-500">
      {data.label}
    </div>
  );
};
